<template>
  <div class="back-to-box" v-show="visible">
    <i class="iconfont glin-shuangjiantoushang" @click="handleScroll(0, 300)"></i>
    <i class="iconfont glin-qingchu" @click="handleClear()"></i>
  </div>
</template>

<script>
import { toScroll, removeStore } from "@/assets/script/utils";
import CacheControl from '@/controller/modules/cacheControl'
export default {
  data () {
    return {
      visible: false
    }
  },

  mounted () {
    this.cacheControl = new CacheControl(
      this.$store.state.chatControl
    )
    window.addEventListener(
      'scroll',
      () => {
        this.visible = window.scrollY > window.innerHeight / 2;
      },
      false
    )
  },

  methods: {
    handleScroll (y, duration) {
      toScroll(0, 200)
    },

    handleClear () {
      this.$createDialog({
        type: 'confirm',
        title: '温馨提示',
        content: '是否要清除历史记录？',
        icon: 'cubeic-alert',
        onConfirm: () => {
          this.cacheControl.remove()
        }
      }).show()
    }
  }
}
</script>

<style lang="stylus">
.back-to-box {
  position: fixed;
  right: 0;
  bottom: 100px;
  z-index: 98;

  .iconfont {
    display: block;
    width: 18px;
    height: 37px;
    line-height: 37px;
    text-align: center;
    font-size: 1.1rem;
    background: #fff;
    border: 1px solid #eee;
  }

  .glin-shuangjiantoushang {
    border-radius: 10px 0 0 0;
    border-bottom: none;
  }

  .glin-qingchu {
    font-size: 0.9rem;
    border-radius: 0 0 0 10px;
  }
}

.cube-popup {
  .cube-dialog-btn_highlight {
    color: #193a79;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/components/backTop.vue